import { gql } from '@apollo/client'

export const GENERATE_WIP_REPORT_SUMMARY = gql`
  mutation generateWipReportSummary(
    $projectId: String!
    $month: String!
    $matterContext: String
    $systemPromptId: ID
    $conversation: [WipChatMessage!]
    $idempotencyKey: String
  ) {
    generateWipReportSummary(
      projectId: $projectId
      month: $month
      matterContext: $matterContext
      systemPromptId: $systemPromptId
      conversation: $conversation
      idempotencyKey: $idempotencyKey
    )
  }
`

export const GENERATE_WIP_REPORT_AI_ORATION = gql`
  mutation generateWipReportAiOration(
    $projectId: String!
    $month: String!
    $idempotencyKey: String
  ) {
    generateWipReportAiOration(
      projectId: $projectId
      month: $month
      idempotencyKey: $idempotencyKey
    )
  }
`

export const LIST_WIP_REPORT_AI_SUMMARIES = gql`
  query listWipReportAiSummaries($projectId: String!, $month: String!) {
    listWipReportAiSummaries(projectId: $projectId, month: $month) {
      id
      month
      label
      createdAt
      hasClientSummary
      hasInternalSummary
    }
  }
`

export const GET_WIP_REPORT_AI_SUMMARY = gql`
  query getWipReportAiSummary($id: ID!) {
    getWipReportAiSummary(id: $id) {
      id
      projectId
      month
      label
      clientSummary
      internalSummary
      createdAt
      hasClientSummary
      hasInternalSummary
    }
  }
`
